import React, { useState } from 'react';
import axios from 'axios';
import LegalLayout, { useLegalLang } from './LegalLayout';

function getApiRoot() {
    const uploads = process.env.REACT_APP_UPLOADS;
    if (uploads) return uploads.replace(/\/$/, '');
    const api = process.env.REACT_APP_API || '';
    return api.replace(/\/api\/admin\/?$/, '').replace(/\/$/, '');
}

export default function DeleteAccount() {
    const [lang, setLang] = useLegalLang();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState(false);
    const [busy, setBusy] = useState(false);
    const [msg, setMsg] = useState(null);

    const submit = async (event) => {
        event.preventDefault();
        setMsg(null);

        if (!confirm) {
            setMsg({
                ok: false,
                text: lang === 'sq'
                    ? 'Ju lutemi konfirmoni që dëshironi të fshini llogarinë.'
                    : 'Please confirm that you want to delete your account.'
            });
            return;
        }

        setBusy(true);
        try {
            const apiRoot = getApiRoot();
            if (!apiRoot) {
                setMsg({
                    ok: false,
                    text: lang === 'sq' ? 'Serveri nuk është konfiguruar.' : 'The server is not configured.'
                });
                return;
            }

            const response = await axios.post(`${apiRoot}/api/public/delete-account`, {
                email: email.trim(),
                password
            }, { timeout: 15000 });
            const data = response.data || {};
            const ok = !data.error;
            setMsg({ ok, text: data.msg || (ok ? 'Your account has been deleted.' : 'Could not delete the account.') });
            if (ok) {
                setEmail('');
                setPassword('');
                setConfirm(false);
            }
        } catch (err) {
            const text = err.response?.data?.msg
                || (lang === 'sq' ? 'Nuk u lidh me serverin. Provoni përsëri.' : 'Could not reach the server. Please try again.');
            setMsg({ ok: false, text });
        } finally {
            setBusy(false);
        }
    };

    return (
        <LegalLayout lang={lang} setLang={setLang} title={lang === 'sq' ? 'Fshi llogarinë' : 'Delete account'}>
            {lang === 'sq' ? (
                <>
                    <p className="legal-lead">Përdorni këtë faqe për të fshirë përgjithmonë llogarinë tuaj Ciceron. Nuk keni nevojë ta keni aplikacionin të instaluar.</p>
                    <p className="legal-retain">Vetëm llogaritë me rolin Mobile mund të fshihen. Llogaritë Admin, Horeca ose City Admin nuk fshihen nga kjo faqe.</p>
                    <p className="legal-danger">Fshirja e llogarisë fshin përgjithmonë llogarinë dhe të dhënat personale të lidhura. Nuk do të mund të hyni më pas.</p>
                    <p className="legal-retain">Disa të dhëna mund të mbeten kur kërkohen për qëllime ligjore, sigurie, llogarie ose rregullatore. Ato ruhen pa emrin, email-in ose telefonin tuaj.</p>
                </>
            ) : (
                <>
                    <p className="legal-lead">Use this page to permanently delete your Ciceron account. You do not need the app installed.</p>
                    <p className="legal-retain">Only Mobile app accounts can be deleted. Admin, Horeca, and City Admin accounts cannot be deleted here.</p>
                    <p className="legal-danger">Deleting your account will permanently delete your account and associated personal data. You will not be able to sign in afterwards.</p>
                    <p className="legal-retain">Some information may be retained where required for legal, security, accounting, or regulatory purposes. Those records are kept without your name, email, or phone number.</p>
                </>
            )}

            <form className="legal-form" onSubmit={submit}>
                <div className="legal-form-row">
                    <label>
                        Email
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="username" />
                    </label>
                    <label>
                        {lang === 'sq' ? 'Fjalëkalimi' : 'Password'}
                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
                    </label>
                </div>
                <label className="legal-confirm">
                    <input type="checkbox" checked={confirm} onChange={(e) => setConfirm(e.target.checked)} />
                    <span>
                        {lang === 'sq'
                            ? 'E kuptoj që llogaria dhe të dhënat e mia personale do të fshihen dhe kjo nuk mund të kthehet mbrapsht.'
                            : 'I understand that my account and personal data will be deleted and this cannot be undone.'}
                    </span>
                </label>
                <button className="legal-submit" type="submit" disabled={busy}>
                    {lang === 'sq' ? 'Fshi llogarinë' : 'Delete Account'}
                </button>
                {msg && <div className={`legal-msg ${msg.ok ? 'ok' : 'error'}`}>{msg.text}</div>}
            </form>
        </LegalLayout>
    );
}
